<script setup>
import ChatMessageAssistant from './ChatMessageAssistant.vue';
import ChatMessageFlight from './ChatMessageFlight.vue';
import ChatMessageToolDebug from './ChatMessageToolDebug.vue';
import ChatMessageUser from './ChatMessageUser.vue';
import { computed } from 'vue';
import { useChatApi } from './useChatApi';

const { isDebug } = useChatApi();


const props = defineProps({
	message: {
		type: Object,
		required: true
	}
});

const flightTools = new Set([
	'searchFlightsOneWay',
	'searchFlightsOpenJaw',
	'searchFlightsReturn',
	'filterFlightSearch'
]);

const mcpTypes = new Set([
	'mcp_call_started',
	'mcp_call_completed'
]);

const messageType = computed(() => {
	const { role, type, content } = props.message;

	const isMcp = mcpTypes.has(type);

	if (isMcp && flightTools.has(content?.name)) {
		return 'tool_flight';
	}

	if (isMcp) {
		return 'tool_generic';
	}

	if (role === 'user') {
		return 'user';
	}

	if (role === 'assistant') {
		return 'assistant';
	}

	return null;
});
</script>

<template>
  <ChatMessageToolDebug
    v-if="isDebug && (messageType === 'tool_generic' || messageType === 'tool_flight')"
    :message="message"
  />

  <ChatMessageUser
    v-if="messageType === 'user'"
    :message="message"
  />

  <ChatMessageAssistant
    v-else-if="messageType === 'assistant'"
    :message="message"
  />

  <ChatMessageFlight
    v-else-if="messageType === 'tool_flight'"
    :message="message"
  />
</template>
